import { render } from "./CommunityChat.vue?vue&type=template&id=dd2021e0&scoped=true"
import script from "./CommunityChat.vue?vue&type=script&lang=js"
export * from "./CommunityChat.vue?vue&type=script&lang=js"

import "./CommunityChat.vue?vue&type=style&index=0&id=dd2021e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd2021e0"]])

export default __exports__